import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import RichTextFormField from '../FormField'

export class EditForm extends React.Component {
  static propTypes = {
    richTextEditorProps: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired
  }

  render () {
    const { richTextEditorProps, handleSubmit } = this.props

    return (
      <Field
        name='content'
        component={RichTextFormField}
        props={{
          richTextEditorProps: {
            ...richTextEditorProps,
            onSubmit: () => handleSubmit()
          },
          errorOnTouched: false
        }} />
    )
  }
}

export default reduxForm({
  form: 'richTextContentEditForm'
})(EditForm)
